<template>
  <div class="order-list-page">
    <div class="breadcrumb flex-rowl">
      <div class="breadcrumb-icon"></div>
      <div class="breadcrumb-content">
        <div class="breadcrumb-content-item">业务订单中心</div>
      </div>
    </div>

    <!-- <div class="select_wrap flex-between">
      <div class="dropdown_wrap">
        <van-dropdown-menu>
          <van-dropdown-item
            v-model="params.service_order_status"
            :options="serviceOrderState"
            @change="changeDropdownStatus"
          />
        </van-dropdown-menu>
      </div>

      <div class="search_btn flex-rowc" @click="isShowTypePopup = true">
        查找订单 <i class="iconfont icon-chazhaotubiao"></i>
      </div>
    </div> -->

    <div class="search-wrap flex-between">
      <div class="search-btn active flex-rowc" @click="isShowTypePopup = true">
        查找业务订单 <i class="search-red-icon"></i>
      </div>
      <div class="search-btn flex-rowc" @click="resetFilter">
        显示所有订单 <i class="search-red-icon"></i>
      </div>
    </div>

    <!-- 其它过滤条件 -->
    <div class="filter-wrap flex-rowl">
      <div
        class="filter-item flex-rowl"
        v-for="(item, index) in filterConditions"
        :key="index"
        @click="handleFilter(item)"
      >
        <p>{{ item.text }}</p>
        <span class="filter-icon"></span>
      </div>
    </div>

    <!-- 服务订单 -->
    <div class="common-list-wrap">
      <div
        class="common-list-content"
        ref="OrderList"
        @scroll="handleScroll"
        v-if="dataList.length > 0 && !isLoading"
      >
        <van-pull-refresh v-model="isRefresh" @refresh="onRefresh">
          <div
            class="common-list-item"
            v-for="(item, index) in dataList"
            :key="index"
            @click="handleDetail(item)"
          >
            <div class="order-info-wrap flex-rowl">
              <div class="order-icon"></div>
              <div class="order-content">
                <p>{{ item.servicecontstr }}</p>
                <p class="flex-rowl">
                  {{ item.order_id }}
                  <span
                    class="copy-icon"
                    @click.stop="copyToClipboard(item.order_id)"
                  ></span>
                </p>
                <p class="txt">{{ formatTime(item.create_time) }}</p>
                <div class="label">
                  <a
                    :href="`tel:${item.createmobile}`"
                    @click.stop="stopPropagation"
                    >联系客户：{{ item.createtruename }}</a
                  >
                </div>
              </div>
            </div>
            <div
              class="user-info-wrap"
              v-if="item.park_catering_service_order_obj"
            >
              <div class="name flex-rowl">
                服务对象：{{
                  item.park_catering_service_order_obj
                    ? item.park_catering_service_order_obj.truename
                    : ""
                }}
                <a
                  :href="`tel:${
                    item.park_catering_service_order_obj &&
                    item.park_catering_service_order_obj.mobile
                      ? item.park_catering_service_order_obj.mobile
                      : ''
                  }`"
                  class="tel-icon"
                  @click.stop="stopPropagation"
                ></a>
              </div>
              <div class="label flex-rowl">
                <p>
                  <span v-if="item.park_catering_service_order_obj.age"
                    >#{{ item.park_catering_service_order_obj.age }}岁</span
                  >
                  <span v-else>未知</span>
                </p>
                <p>
                  #{{
                    item.park_catering_service_order_obj.isself == 1
                      ? "有独立行动能力"
                      : "无独立行动能力"
                  }}
                </p>
              </div>
              <div class="state">
                <p>
                  服务预约时间：{{
                    item.servicecont == 3 ||
                    item.servicecont == 11 ||
                    item.servicecont == 13
                      ? formatTime(item.create_time)
                      : formatTime(item.asktime)
                  }}
                </p>
                <p>
                  状态：<span class="blue">{{
                    item.service_order_statusstr
                  }}</span>
                  <span v-if="item.service_order_status == 4" class="blue">{{
                    item.service_rating == 1
                      ? "不满意"
                      : item.service_rating == 2
                      ? "满意"
                      : item.service_rating == 3
                      ? "非常满意"
                      : ""
                  }}</span>
                  <span
                    class="management-btn"
                    v-if="item.service_order_status == 7"
                    @click.stop="handleShowManagePopup(item, 1)"
                    >管理</span
                  >
                </p>
                <!-- <p>
                  分配：<span
                    :class="{
                      red: item.park_catering_service_order_get.length == 0,
                    }"
                    >{{
                      item.park_catering_service_order_get.length > 0
                        ? "已分配"
                        : "待分配"
                    }}</span
                  >
                </p> -->
                <div class="state-block flex-rowl">
                  <p>分配：</p>
                  <div class="content">
                    <p>
                      <span>{{
                        item.totype == 1
                          ? "派单给陪护服务合作机构"
                          : item.totype == 2
                          ? "派单给小铃铛陪护员"
                          : "待分配业务人员"
                      }}</span>
                    </p>
                    <div class="content-list">
                      <p
                        v-for="(
                          itemChild, indexChild
                        ) in item.park_catering_service_order_get"
                        :key="indexChild"
                        class="flex-rowl"
                      >
                        {{
                          item.totype == 1
                            ? itemChild.insname
                            : item.totype == 2
                            ? itemChild.get_staff_name
                            : ""
                        }}
                        <a
                          :href="`tel:${
                            item.totype == 1
                              ? itemChild.mobile
                              : item.totype == 2
                              ? itemChild.get_staff_contact
                              : ''
                          }`"
                          class="tel-icon"
                          @click.stop="stopPropagation"
                        ></a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="price-block">
                <div class="price-wrap">
                  <p>
                    基础费用：<span :class="{ red: !item.timeoutprice }">{{
                      item.timeoutprice ? "¥" + item.timeoutprice : "待核算"
                    }}</span>
                  </p>
                  <p>
                    支付状态：<span
                      :class="{ red: item.isreturn != 2 }"
                      v-if="item.isreturn == 1"
                      >{{
                        item.returncheck == 1
                          ? "已退款"
                          : item.returncheck == 2
                          ? "退款，不同意"
                          : "退款中"
                      }}</span
                    >
                    <span :class="{ red: item.ispay != 1 }" v-else>{{
                      item.ispaystr ? item.ispaystr : "待支付"
                    }}</span>
                    <span
                      class="management-btn"
                      v-if="
                        item.service_order_status == 8 &&
                        item.ispay == 1 &&
                        item.isreturn != 1
                      "
                      @click.stop="handleShowManagePopup(item, 2)"
                      >管理</span
                    >
                  </p>
                  <p>
                    支付方式：<span v-if="item.paytype">{{
                      item.ispaystr
                        ? item.paytype == 1
                          ? item.paytypestr
                          : item.paytypestr +
                            "，" +
                            (item.getmancardno ? "已确认" : "待确认")
                        : ""
                    }}</span
                    ><span class="red" v-else>无</span>
                  </p>
                </div>
                <!-- 超时收费 -->
                <div class="price-wrap">
                  <p>
                    超时费用：<span
                      :class="{
                        red: !item.park_catering_service_order_fee_obj.fee,
                      }"
                      >{{
                        item.park_catering_service_order_fee_obj.fee
                          ? "¥" + item.park_catering_service_order_fee_obj.fee
                          : "无"
                      }}</span
                    >
                  </p>
                  <p>
                    支付状态：<span
                      :class="{
                        red:
                          item.park_catering_service_order_fee_obj.paystate !=
                          1,
                      }"
                      >{{
                        item.park_catering_service_order_fee_obj.paystate == 1
                          ? "已支付"
                          : item.park_catering_service_order_fee_obj.paystate ==
                            2
                          ? "待支付"
                          : "无"
                      }}</span
                    >
                  </p>
                  <p>
                    支付方式：<span
                      v-if="item.park_catering_service_order_fee_obj.paytype"
                      >{{
                        item.park_catering_service_order_fee_obj.paytype == 1
                          ? "线上支付"
                          : "线下现金结算" +
                            "，" +
                            (item.park_catering_service_order_fee_obj.hrcode
                              ? "已确认"
                              : "待确认")
                      }}</span
                    ><span class="red" v-else>无</span>
                  </p>
                </div>
                <!-- 额外交通费用 -->
                <div class="price-wrap">
                  <p>
                    额外交通费用：<span
                      :class="{
                        red: !item.park_catering_service_order_feetraffic_obj
                          .fee,
                      }"
                      >{{
                        item.park_catering_service_order_feetraffic_obj.fee
                          ? "¥" +
                            item.park_catering_service_order_feetraffic_obj.fee
                          : "无"
                      }}</span
                    >
                  </p>
                  <p>
                    支付状态：<span
                      :class="{
                        red:
                          item.park_catering_service_order_feetraffic_obj
                            .paystate != 1,
                      }"
                      >{{
                        item.park_catering_service_order_feetraffic_obj
                          .paystate == 1
                          ? "已支付"
                          : item.park_catering_service_order_feetraffic_obj
                              .paystate == 2
                          ? "待支付"
                          : "无"
                      }}</span
                    >
                  </p>
                  <p>
                    支付方式：<span
                      v-if="
                        item.park_catering_service_order_feetraffic_obj.paytype
                      "
                      >{{
                        item.park_catering_service_order_feetraffic_obj
                          .paytype == 1
                          ? "线上支付"
                          : "线下现金结算" +
                            "，" +
                            (item.park_catering_service_order_feetraffic_obj
                              .hrcode
                              ? "已确认"
                              : "待确认")
                      }}</span
                    ><span class="red" v-else>无</span>
                  </p>
                </div>
                <!-- 其他额外费用 -->
                <div class="price-wrap">
                  <p>
                    其他额外费用：<span
                      :class="{
                        red: !item.park_catering_service_order_feeother_obj.id,
                      }"
                      >{{
                        item.park_catering_service_order_feeother_obj.id
                          ? "¥" +
                            item.park_catering_service_order_feeother_obj.fee
                          : "无"
                      }}</span
                    >
                    <span
                      v-if="
                        item.park_catering_service_order_feeother_obj.feetype
                      "
                      >{{
                        item.park_catering_service_order_feeother_obj.feetype ==
                        1
                          ? "药品购买费用"
                          : item.park_catering_service_order_feeother_obj
                              .feetype == 2
                          ? "挂号费"
                          : item.park_catering_service_order_feeother_obj
                              .feetype == 3
                          ? "检查预约付费"
                          : item.park_catering_service_order_feeother_obj
                              .feetype == 4
                          ? "住院押金"
                          : "其它额外费用"
                      }}</span
                    >
                  </p>
                  <p>
                    支付状态：<span
                      :class="{
                        red:
                          item.park_catering_service_order_feeother_obj
                            .paystate != 1,
                      }"
                      >{{
                        item.park_catering_service_order_feeother_obj
                          .paystate == 1
                          ? "已支付"
                          : item.park_catering_service_order_feeother_obj
                              .paystate == 2
                          ? "待支付"
                          : "无"
                      }}</span
                    >
                  </p>
                  <p>
                    支付方式：<span
                      v-if="
                        item.park_catering_service_order_feeother_obj.paytype
                      "
                      >{{
                        item.park_catering_service_order_feeother_obj.paytype ==
                        1
                          ? "线上支付"
                          : "线下现金结算" +
                            "，" +
                            (item.park_catering_service_order_feeother_obj
                              .hrcode
                              ? "已确认"
                              : "待确认")
                      }}</span
                    ><span class="red" v-else>无</span>
                  </p>
                </div>
              </div>
            </div>
            <div class="operation-wrap flex-rowr">
              <div
                class="operation-item flex-rowc"
                @click.stop="previewImage(item.order_ercode, 0)"
                v-if="
                  item.service_order_status == 2 ||
                  item.service_order_status == 4
                "
              >
                业务码
              </div>
              <div
                class="operation-item flex-rowc"
                :class="{
                  success: item.service_order_status >= 5,
                }"
              >
                <span class="icon"></span
                >{{
                  item.service_order_status == 5
                    ? "已完成（待评价）"
                    : item.service_order_status == 6
                    ? "已完成（已评价）"
                    : item.service_order_statusstr
                }}
              </div>
            </div>
          </div>
        </van-pull-refresh>

        <div class="common-no-more flex-rowc" v-if="hasMore">
          暂无更多数据...
        </div>
      </div>
      <!-- 加载提示 -->
      <div class="common-loading-wrap flex-rowc" v-if="isLoading">
        <van-loading type="spinner" vertical>加载中...</van-loading>
      </div>
      <div
        class="common-no-data flex-rowc"
        v-if="dataList.length == 0 && !isLoading"
      >
        <van-empty description="暂无数据" />
      </div>
    </div>

    <!-- 用户取消订单、退款管理处理 -->
    <CustomPopup :visible="isShowPopup" position="center" @close="closePopup">
      <div class="order-popup-content" v-if="customerPopupType == 1">
        <div class="tit">
          <h1>用户取消订单的原因</h1>
          <p>{{ currentOrder.cancelreasonstr }}</p>
        </div>
        <div class="popup-main calcel-order-popup-main">
          <div class="radio-wrap">
            <p class="txt">客服处理：</p>
            <div
              class="radio-item flex-rowl"
              :class="{ selected: customerServiceType == 1 }"
              @click="customerServiceType = 1"
            >
              <span></span>
              <p>与用户协商成功，继续服务</p>
            </div>
            <div
              class="radio-item flex-rowl"
              :class="{ selected: customerServiceType == 2 }"
              @click="customerServiceType = 2"
            >
              <span></span>
              <p>确认同意取消本次服务</p>
            </div>
          </div>
        </div>
        <div
          class="popup-query-btn flex-rowc"
          :class="{ disabled: isSubmitting }"
          @click="handleCancelOrder"
        >
          确认
        </div>
      </div>
      <div class="order-popup-content" v-else-if="customerPopupType == 2">
        <div class="tit">退款管理</div>
        <div class="price"><span>¥</span>{{ currentOrder.timeoutprice }}</div>
        <div class="popup-main refund-popup-main">
          <p class="sub_tit">
            支付方式：{{
              currentOrder.ispaystr
                ? currentOrder.paytype == 1
                  ? currentOrder.paytypestr
                  : currentOrder.paytypestr +
                    "，" +
                    (currentOrder.getmancardno ? "已确认" : "待确认")
                : ""
            }}
          </p>
          <div class="radio-wrap">
            <div
              class="radio-item flex-rowl"
              :class="{ selected: refundParams.returntype == 1 }"
              @click="refundParams.returntype = 1"
            >
              <span></span>
              <p>全额退款</p>
            </div>
            <div
              class="radio-item flex-rowl"
              :class="{ selected: refundParams.returntype == 2 }"
              @click="refundParams.returntype = 2"
            >
              <span></span>
              <p>部分退款</p>
            </div>
            <div class="radio-item-input">
              <input
                type="number"
                placeholder="输入退款金额"
                v-model="refundParams.refund_amount"
              />
            </div>
          </div>
        </div>
        <div
          class="popup-query-btn flex-rowc"
          :class="{ disabled: isSubmitting }"
          @click="handleRefundOrder"
        >
          确认
        </div>
      </div>
    </CustomPopup>

    <!-- 选择类型弹窗 start -->
    <CustomPopup
      :visible="isShowTypePopup"
      position="center"
      @close="isShowTypePopup = false"
    >
      <div class="popup_container">
        <div class="popup_wrap">
          <div
            class="btn_item flex-between"
            @click="handleShowTextArea('order_id')"
          >
            <p>使用订单号查找</p>
            <i class="iconfont icon-youjiantou"></i>
          </div>
          <div
            class="btn_item flex-between"
            @click="handleShowTextArea('createtruename')"
          >
            <p>使用客户姓名查找</p>
            <i class="iconfont icon-youjiantou"></i>
          </div>
          <div
            class="btn_item flex-between"
            @click="handleShowTextArea('truename_obj')"
          >
            <p>使用服务对象姓名查找</p>
            <i class="iconfont icon-youjiantou"></i>
          </div>
        </div>
      </div>
    </CustomPopup>
    <!-- 选择类型弹窗 end -->

    <!-- 输入框弹窗 start -->
    <CustomPopup
      :visible="isShowTextAreaPopup"
      position="center"
      @close="isShowTextAreaPopup = false"
    >
      <div class="popup_container">
        <div class="popup_wrap">
          <div class="textarea_box">
            <van-field
              type="textarea"
              v-model="params.keyword"
              :placeholder="
                popupType == 'order_id'
                  ? '请输入订单号'
                  : popupType == 'createtruename'
                  ? '请输入客户姓名'
                  : '请输入服务对象姓名'
              "
            />
          </div>
          <div class="custom_btn" @click="handleSearch">
            开始查找 <i class="iconfont icon-yuyinjiantou"></i>
          </div>
        </div>
      </div>
    </CustomPopup>

    <!-- 其它筛选弹窗 start -->
    <CustomPopup
      :visible="isShowFilterPopup"
      :isRadius="false"
      position="center"
      @close="isShowFilterPopup = false"
    >
      <div class="popup_filter_container">
        <div class="filter_list_wrap">
          <div
            class="filter_item_wrap flex-rowl"
            v-for="(item, index) in selectedFilterId == 1 ? serviceType : selectedFilterId == 2 ? orderState : selectedFilterId == 3 ? payState : payConfirm"
            :key="index"
            @click="handleShowFilter(item)"
          >
            <p>{{ item.text }}</p>
            <p>{{ item.text2 }}</p>
          </div>
        </div>
      </div>
    </CustomPopup>

    <!-- 图片预览 -->
    <ImagePreviewComponent
      v-if="showPreviewComponent"
      :images="previewImages"
      :initialIndex="previewIndex"
      @close="closePreview"
    />
  </div>
</template>
  
  <script>
import Clipboard from "clipboard";
import {
  getCommunityServiceOrderList,
  editCommunityServiceOrder,
  getServiceTypeList,
} from "../../../api/api";
import { submitRefund } from "../../../api/public";
import CustomPopup from "../../../components/CustomPopup.vue";
import { mapState } from "vuex";
import ImagePreviewComponent from "../../../components/ImagePreviewComponent.vue";

export default {
  name: "OrderList",
  components: {
    CustomPopup,
    ImagePreviewComponent,
  },
  data() {
    return {
      // 图片预览
      showPreviewComponent: false,
      previewImages: [],
      previewIndex: 0,

      params: {
        pageindex: 1,
        pagesize: 10,
        keyword: "",
        servicetype: "", // 订单服务类型 =1=常规陪护服务|2=长期居家护理服务|3=其他陪护服务|
        service_order_status: "",
      },
      dataList: [], //
      totalPage: 1, // 总页数
      isLoading: true, // 是否正在加载
      hasMore: false, // 是否还有更多数据
      isLoadingMore: false, // 新增加载状态锁
      isRefresh: false, // 是否正在刷新
      // 服务订单状态
      serviceOrderState: [
        {
          text: "所有状态订单",
          value: "",
        },
        // {
        //   text: "待接单",
        //   value: 1,
        // },
        // {
        //   text: "服务中",
        //   value: 2,
        // },
        // {
        //   text: "服务已完成（待评价）",
        //   value: 3,
        // },
        // {
        //   text: "服务已完成（已评价）",
        //   value: 4,
        // },
      ],

      // 筛选条件
      filterConditions: [
        {
          text: "业务",
          value: 1,
        },
        {
          text: "状态",
          value: 2,
        },
        {
          text: "付款状态",
          value: 3,
        },
        {
          text: "付款确认",
          value: 4,
        },
      ],
      // 选中的筛选条件
      selectedFilterId: '',
      isShowFilterPopup: false, // 是否显示其它筛选弹窗
      // 服务类型
      serviceType: [],
      // 订单状态
      orderState: [
        {
          text: "所有服务",
          value: '',
        },
        {
          text: "待接单",
          value: 1,
        },
        {
          text: "服务中",
          value: 2,
        },
        {
          text: "服务已完成（待评价）",
          value: 3,
        },
        {
          text: "服务已完成（已评价）",
          value: 4,
        },
      ],
      // 付款状态
      payState: [
        {
          text: "所有服务",
          value: '',
        },
        {
          text: "线上支付",
          text2: "待支付",
          value: 1,
          value2: 0,
        },
        {
          text: "线上支付",
          text2: "已支付",
          value: 1,
          value2: 1,
        },
        {
          text: "线下现金结算",
          text2: "待支付",
          value: 2,
          value2: 0,
        },
        {
          text: "线下现金结算",
          text2: "已支付",
          value: 2,
          value2: 1,
        },
      ],
      // 付款确认
      payConfirm: [
        {
          text: "所有服务",
          value: '',
        },
        // {
        //   text: "线上支付",
        //   text2: "未确认支付",
        //   value: 1,
        //   value2: 0,
        // },
        // {
        //   text: "线上支付",
        //   text2: "确认支付",
        //   value: 1,
        //   value2: 1,
        // },
        {
          text: "线下现金结算",
          text2: "未确认支付",
          value: 2,
          value2: 0,
        },
        {
          text: "线下现金结算",
          text2: "确认支付",
          value: 2,
          value2: 1,
        },
      ],

      isShowTypePopup: false, // 是否显示选择类型弹窗
      popupType: "", // order_id-订单号、createtruename-客户姓名、truename_obj-服务对象姓名
      isShowTextAreaPopup: false, // 是否显示输入框弹窗
      textAreaValue: "", // 输入框的值

      isSubmitting: false, // 是否正在提交
      isShowPopup: false, // 是否显示弹窗
      // 操作的当前数据
      currentOrder: {},
      customerPopupType: "", // 1-取消订单、2-退款管理
      // 客服处理类型
      customerServiceType: "", // 1-与用户协商成功，继续服务、2-确认同意取消本次服务

      // 退款参数
      refundParams: {
        isreturn: 1, // 是否退款 =1=是|0=否|
        refund_amount: "", // 退款金额
        returntype: "", // 申请退款类型 =1=全额退款|2=部分退款|
        returncheck: 0,
      },
    };
  },
  computed: {
    ...mapState(["USERINFO"]),
  },
  async mounted() {
    this.getCommunityServiceOrderList();
    this.getServiceTypeList();
  },
  methods: {
    // 定义时间格式化方法
    formatTime(timeStr) {
      if (!timeStr) return "";
      return timeStr.replace("T", " ");
    },

    // 封装转换数组为对象的函数
    getFirstItemOrEmptyArray(arr) {
      return Array.isArray(arr) && arr.length > 0 ? arr[0] : {};
    },

    // 获取服务类型列表
    async getServiceTypeList() {
      try {
        const res = await getServiceTypeList();
        if (res.list) {
          // 初始化结果数组，包含固定的"所有服务"项
          const result = [{ text: "所有服务", text1: "", value: "" }];

          // 处理输入数组中的每一项
          res.list.forEach((serviceItem) => {
            // 检查是否有cont子数组
            if (serviceItem.cont && Array.isArray(serviceItem.cont)) {
              // 复制cont数组并按sortno排序
              const sortedCont = [...serviceItem.cont].sort((a, b) => {
                // 确保sortno是数字类型进行比较
                const sortA = parseInt(a.sortno) || 0;
                const sortB = parseInt(b.sortno) || 0;
                return sortA - sortB;
              });

              // 将排序后的子项添加到结果数组
              sortedCont.forEach((subItem) => {
                result.push({
                  text: serviceItem.typename,
                  text2: subItem.typename,
                  value: subItem.id,
                });
              });
              this.serviceType = result;
            }
          });
        }
      } catch (error) {
        console.error("获取服务类型列表失败", error);
      }
    },

    // 获取陪护服务订单
    async getCommunityServiceOrderList() {
      try {
        const res = await getCommunityServiceOrderList(this.params);
        if (res.list) {
          res.list.forEach((v) => {
            v.park_catering_service_order_get.map((item) => {
              const firstBellInstitution = item.bell_institution[0] || {};
              // 直接修改 item 对象的属性
              item.insname = firstBellInstitution.insname;
              item.mobile = firstBellInstitution.mobile;
              item.tel = firstBellInstitution.tel;
              item.logo = firstBellInstitution.logo;
            });
            // 使用封装函数转换数组为对象
            v.park_catering_service_order_fee_obj =
              this.getFirstItemOrEmptyArray(v.park_catering_service_order_fee);
            v.park_catering_service_order_feetraffic_obj =
              this.getFirstItemOrEmptyArray(
                v.park_catering_service_order_feetraffic
              );
            v.park_catering_service_order_feeother_obj =
              this.getFirstItemOrEmptyArray(
                v.park_catering_service_order_feeother
              );
          });
          this.dataList = this.dataList.concat(res.list);
          this.totalPage = res.total;
        }
      } catch (error) {
        console.error("获取街道列表失败", error);
      } finally {
        // 等待 800 毫秒后关闭加载提示
        await new Promise((resolve) => setTimeout(resolve, 500));
        this.isLoading = false;
      }
    },

    // 修改陪护服务订单
    async editCommunityServiceOrder(data) {
      try {
        let params = {
          ...data,
          id: this.currentOrder.id,
        };
        let res = await editCommunityServiceOrder(params);
        if (!res.result) {
          throw new Error(res.message || "提交失败，请稍后重试");
        }
        // 获取服务订单
        await new Promise((resolve) => setTimeout(resolve, 500));
        this.$toast.success(res.message);
        this.updateCommunityServiceOrderList();
        this.isShowPopup = false;
        this.isSubmitting = false;
      } catch (error) {
        this.$toast.fail(error.message || "更新失败");
        this.isSubmitting = false;
        this.isShowPopup = false;
      }
    },

    // 获取更新的服务订单列表
    async updateCommunityServiceOrderList() {
      try {
        let params = {
          pageindex: 1,
          pagesize: 1,
          order_id: this.currentOrder.order_id,
        };
        let res = await getCommunityServiceOrderList(params);
        if (res.list.length > 0) {
          this.updateOrderDataById(this.currentOrder.id, res.list[0]);
        } else {
          this.updateOrderDataById(this.currentOrder.id);
        }
      } catch (error) {
        this.$toast.fail(error.message || "更新失败");
        this.isSubmitting = false;
      }
    },

    updateOrderDataById(id, newData) {
      const index = this.dataList.findIndex((item) => item.id === id);
      if (index !== -1) {
        if (newData) {
          // 如果有新数据，更新列表中的对应项
          this.$set(this.dataList, index, {
            ...this.dataList[index],
            ...newData,
          });
        } else {
          // 如果没有新数据，仅触发响应式更新
          this.$set(this.dataList, index, {
            ...this.dataList[index],
          });
        }
      }
    },

    // 下拉刷新
    async onRefresh() {
      // 等待 800 毫秒后关闭加载提示
      await new Promise((resolve) => setTimeout(resolve, 500));
      this.isRefresh = false;
      this.params.pageindex = 1;
      this.params.keyword = "";
      this.params.servicetype = "";
      this.params.service_order_status = "";
      this.dataList = [];

      this.getCommunityServiceOrderList();
    },

    changeDropdownStatus(e) {
      this.params.service_order_status = e;
      this.params.pageindex = 1;
      this.dataList = [];
      this.getCommunityServiceOrderList();
    },

    handleShowTextArea(type) {
      this.popupType = type;
      this.params.keyword = "";
      this.isShowTypePopup = false;
      this.isShowTextAreaPopup = true;
    },

    handleSearch() {
      let { popupType, params } = this;
      if (!params.keyword) {
        this.$toast(
          popupType == "order_id"
            ? "请输入订单号"
            : popupType == "createtruename"
            ? "请输入客户姓名"
            : "请输入服务对象姓名"
        );
        return;
      }
      this.isShowTextAreaPopup = false;
      this.isLoading = true;
      this.params.pageindex = 1;
      this.dataList = [];
      this.getCommunityServiceOrderList();
    },

    // 显示其它筛选弹窗
    handleFilter(item) {
      this.selectedFilterId = item.value;
      this.isShowFilterPopup = true;
    },

    // 处理筛选条件选择
    handleShowFilter(item) {
      let { selectedFilterId } = this;
      if (selectedFilterId == 1) {
        this.params.servicecont = item.value;
        this.params.service_order_status = '';
        this.params.paytype = '';
        this.params.ispay = '';
        this.params.issub = '';
      } else if (selectedFilterId == 2) {
        this.params.servicecont = '';
        this.params.service_order_status = item.value;
        this.params.paytype = '';
        this.params.ispay = '';
        this.params.issub = '';
      } else if (selectedFilterId == 3) {
        this.params.servicecont = '';
        this.params.service_order_status = '';
        this.params.paytype = item.value;
        this.params.ispay = item.value2;
        this.params.issub = '';
      } else if (selectedFilterId == 4) {
        this.params.servicecont = '';
        this.params.service_order_status = '';
        this.params.paytype = item.value;
        this.params.ispay = '';
        this.params.issub = item.value2;
      }

      this.isShowFilterPopup = false;
      this.isLoading = true;
      this.params.pageindex = 1;
      this.dataList = [];
      this.getCommunityServiceOrderList();
    },

    // 重置筛选条件
    resetFilter() {
      this.params.servicecont = '';
      this.params.service_order_status = '';
      this.params.paytype = '';
      this.params.ispay = '';
      this.params.issub = '';
      this.params.keyword = '';
      this.isLoading = true;
      this.params.pageindex = 1;
      this.dataList = [];
      this.getCommunityServiceOrderList();
    },

    // 处理滚动事件
    handleScroll() {
      const { scrollTop, scrollHeight, clientHeight } = this.$refs.OrderList;
      let { dataList, totalPage, isLoadingMore } = this;
      if (isLoadingMore || dataList.length >= totalPage) return;
      // 当滚动到底部 20px 范围内时触发加载
      if (scrollTop + clientHeight >= scrollHeight - 20) {
        this.hasMore = true;
        this.params.pageindex++;
        this.isLoadingMore = true; // 开始加载，设置锁
        this.getCommunityServiceOrderList().finally(() => {
          this.isLoadingMore = false; // 加载完成，释放锁
        });
      }
    },

    // 复制
    copyToClipboard(text) {
      const tempElement = document.createElement("button");
      tempElement.setAttribute("data-clipboard-text", text);
      const clipboard = new Clipboard(tempElement);

      clipboard.on("success", () => {
        this.$toast.success("复制成功");
        clipboard.destroy();
      });

      clipboard.on("error", () => {
        this.$toast.fail("复制失败");
        clipboard.destroy();
      });

      // 手动触发复制操作
      tempElement.click();
    },

    // 阻止事件冒泡事件
    stopPropagation() {},

    handleDetail(item) {
      if (item.servicecont == 3) {
        // 代拿报告
        this.$router.push({
          name: "OrderReportDetail",
          query: { id: item.id },
        });
      } else if (item.servicecont == 11) {
        // 代配药
        this.$router.push({
          name: "MedicineDispatchDetail",
          query: { id: item.id },
        });
      } else if (item.servicecont == 12) {
        // 代问诊
        this.$router.push({
          name: "InquiryAgencyDetail",
          query: { id: item.id },
        });
      } else if (item.servicecont == 13) {
        // 预约检查
        this.$router.push({
          name: "AppointmentCheckDetail",
          query: { id: item.id },
        });
      } else if (item.servicecont == 14) {
        // 代办住院/出院
        this.$router.push({
          name: "InHospitalDetail",
          query: { id: item.id },
        });
      } else if (item.servicecont == 15) {
        // 代办入院/出院
        this.$router.push({
          name: "InHospitalInDetail",
          query: { id: item.id },
        });
      } else {
        this.$router.push({ name: "OrderDetail", query: { id: item.id } });
      }
    },

    // 预览图片
    previewImage(image) {
      this.showPreviewComponent = true;
      this.previewImages = [image];
    },
    // 关闭图片预览
    closePreview() {
      this.showPreviewComponent = false;
    },

    // 显示弹窗
    handleShowManagePopup(item, type) {
      this.customerPopupType = type;
      this.currentOrder = item;
      this.isShowPopup = true;
    },

    // 关闭弹窗
    closePopup() {
      this.isShowPopup = false;
    },

    // 提取服务订单状态计算逻辑为独立函数
    calculateServiceOrderStatus(customerServiceType, currentOrder) {
      if (customerServiceType == 2) {
        return {
          service_order_status: 8,
        };
      }
      if (currentOrder.ispay == 1) {
        return {
          service_order_status: 4,
          iscancel: 0,
          cancelreason: "",
        };
      }
      return {
        service_order_status:
          currentOrder.park_catering_service_order_get.length == 0 ? 1 : 2,
        iscancel: 0,
        cancelreason: "",
      };
    },

    // 用户订单取消管理
    async handleCancelOrder() {
      const { customerServiceType, currentOrder } = this;

      if (!customerServiceType) {
        this.$toast("请选择客服处理");
        return;
      }

      // 标记为正在提交
      this.isSubmitting = true;

      const loadingToast = this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "提交中...",
      });

      try {
        const result = this.calculateServiceOrderStatus(
          customerServiceType,
          currentOrder
        );
        await this.editCommunityServiceOrder(result);
      } catch (error) {
        console.error("用户订单取消管理失败:", error);
      } finally {
        loadingToast.clear(); // 关闭加载提示
        this.isSubmitting = false;
      }
    },
    // 退款管理
    async handleRefundOrder() {
      let { refund_amount, returntype } = this.refundParams;
      if (!returntype) {
        this.$toast("请选择退款类型");
        return;
      }
      if (returntype == 2 && !refund_amount) {
        this.$toast("请输入退款金额");
        return;
      }

      // 如果为全部退款，则退款金额为订单金额
      if (returntype == 1) {
        this.refundParams.refund_amount = this.currentOrder.timeoutprice;
      }

      // 标记为正在提交
      this.isSubmitting = true;

      this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "提交中...",
      });

      // 判断订单支付方式
      if (this.currentOrder.paytype == 1) {
        await this.submitRefund();
      } else {
        this.editCommunityServiceOrder(this.refundParams);
      }
    },
    // 线上支付退费申请
    async submitRefund() {
      try {
        let params = {
          orderid: this.currentOrder.service_order_id,
          truename: this.USERINFO.truename,
          logtype: 1008, // 1008=健康服务订单退款
          reasonid: 10, // 退费原因 从接口64获取id
          returnnote: 1,
          returnattr: 6,
          fee: this.refundParams.refund_amount,
        };
        let res = await submitRefund(params);
        if (!res.result) {
          throw new Error(res.message || "提交失败，请稍后重试");
        }
        await new Promise((resolve) => setTimeout(resolve, 500));
        this.editCommunityServiceOrder(this.refundParams);
      } catch (error) {
        this.$toast.fail(error.message || "更新失败");
        this.isSubmitting = false;
      }
    },
  },
};
</script>
  
  <style lang="less">
.order-list-page {
  .breadcrumb {
    padding: 50px 0 34px;
    box-sizing: border-box;
    width: 620px;
    margin: auto;
    font-size: 28px;
    color: #1e1e1e;
    .breadcrumb-icon {
      position: relative;
      margin-right: 18px;
      width: 33px;
      height: 30px;
      background: url(../../../assets/images/order-title-icon.png) no-repeat
        center;
      background-size: cover;
    }
  }
  .select_wrap {
    width: 700px;
    margin: 0 auto 30px;
    box-sizing: border-box;
    .dropdown_wrap {
      width: 550px;
      flex-shrink: 0;
    }
    .select_item {
      margin-top: 20px;
      height: 80px;
      border-bottom: 1px dashed #2c2b2b;
      font-size: 30px;
      color: #333333;
      padding: 0 14px;
      .icon-toTop {
        transform: rotate(180deg);
        font-size: 20px;
      }
    }
    /deep/ .van-dropdown-menu__bar {
      box-shadow: none;
    }
    /deep/ .van-dropdown-menu__title {
      width: 280px;
      box-sizing: border-box;
      text-align: center;
      padding: 0 30px 0 15px;
    }
    /deep/ .van-dropdown-menu__title::after {
      right: 20px;
      border-color: transparent transparent #c4c5c6 #c4c5c6;
    }
    .search_btn {
      flex-shrink: 0;
      width: 160px;
      font-size: 24px;
      background: #373737;
      color: #fff;
      margin-left: 10px;
      white-space: nowrap;
      height: 95px;
      cursor: pointer;
      .iconfont {
        font-size: 28px;
        margin-left: 5px;
        font-size: 26px;
        color: #000000;
      }
    }
  }
  .search-wrap {
    padding: 0 30px;
    box-sizing: border-box;
    .search-btn {
      width: 335px;
      height: 60px;
      background: #ffffff;
      box-shadow: 0px 0px 10px 0px rgba(10, 1, 3, 0.1);
      border-radius: 30px;
      font-size: 28px;
      cursor: pointer;
      &.active {
        color: #da2532;
      }
      .search-red-icon {
        width: 30px;
        height: 30px;
        margin-left: 18px;
        background: url("../../../assets/images/search-red-icon.png") no-repeat
          center;
        background-size: cover;
        display: inline-block;
      }
    }
  }
  .filter-wrap {
    padding: 40px 90px;
    box-sizing: border-box;
    font-size: 26px;
    .filter-item {
      cursor: pointer;
      margin-right: 40px;
      p {
        white-space: nowrap;
      }
    }
    .filter-icon {
      width: 30px;
      height: 30px;
      margin-left: 7px;
      background: url("../../../assets/images/filter-icon.png") no-repeat center;
      background-size: cover;
      display: inline-block;
    }
  }
  .common-list-wrap {
    width: 700px;
    margin: auto;
    .common-list-content {
      margin: auto;
      height: 82vh;
      overflow-y: scroll;
      padding-bottom: 180px;
      box-sizing: border-box;
      // 隐藏滚动条
      &::-webkit-scrollbar {
        display: none;
      }
      .common-list-item {
        width: 100%;
        background: #fff;
        border-radius: 60px;
        padding: 40px 0;
        box-sizing: border-box;
        font-size: 20px;
        align-items: flex-start;
        color: #333333;
        margin-bottom: 30px;
        cursor: pointer;
        .order-info-wrap {
          width: 100%;
          padding: 0 50px;
          align-items: flex-start;
          box-sizing: border-box;
          .order-icon {
            width: 83px;
            height: 50px;
            background: url("../../../assets/images/order-icon.png") no-repeat
              center;
            background-size: cover;
            margin-right: 17px;
          }
          .order-content {
            flex: 1;
            p {
              font-size: 36px;
              color: #333333;
              line-height: 46px;
              &.txt {
                font-size: 30px;
                color: #999999;
                margin: 16px 0 19px;
                line-height: 30px;
              }
            }
            .label {
              background: #f5f7fb;
              display: inline-block;
              font-size: 32px;
              color: #2854cb;
              padding: 15px 14px;
              box-sizing: border-box;
              min-width: 480px;
              a {
                width: 100%;
                height: 100%;
                font-size: 32px;
                color: #2854cb;
              }
            }
            .copy-icon {
              display: inline-block;
              width: 40px;
              height: 43px;
              background: url("../../../assets/images/copy1-icon.png") no-repeat
                center;
              background-size: cover;
              margin-left: 30px;
            }
          }
        }
        .user-info-wrap {
          padding: 0 50px;
          box-sizing: border-box;
          .name {
            font-size: 32px;
            color: #333333;
            margin: 29px 0 28px;
            .tel-icon {
              display: inline-block;
              width: 40px;
              height: 51px;
              background: url("../../../assets/images/photo-icon.png") no-repeat
                center;
              background-size: cover;
              margin-left: 30px;
            }
          }
          .label {
            font-size: 28px;
            margin-bottom: 30px;
            color: #2854cb;
            p {
              margin-right: 30px;
              &:last-child {
                margin-right: 0;
              }
            }
          }
          .txt {
            // margin: 28px 0 38px;
            font-size: 28px;
            color: #333333;
            p {
              margin-bottom: 12px;
              &:last-child {
                margin-bottom: 0;
              }
            }
          }
          .state {
            margin: 38px 0 40px;
            font-size: 30px;
            color: #333333;
            p {
              margin-bottom: 24px;
              &:last-child {
                margin-bottom: 0;
              }
              .red {
                color: #fe0000;
              }
              .blue {
                color: #2854cb;
              }
            }
            .state-block {
              margin-bottom: 24px;
              align-items: flex-start;
              p {
                margin-bottom: 0;
              }
              .content-list {
                margin-top: 15px;
                p {
                  margin-bottom: 10px;
                  &:last-child {
                    margin-bottom: 0;
                  }
                  .tel-icon {
                    display: inline-block;
                    width: 40px;
                    height: 51px;
                    background: url("../../../assets/images/photo-icon.png")
                      no-repeat center;
                    background-size: cover;
                    margin-left: 30px;
                  }
                }
              }
            }
          }
          .price-block {
            margin-bottom: 50px;
            .price-wrap {
              margin-bottom: 35px;
              p {
                font-size: 26px;
                margin-bottom: 20px;
                &:last-child {
                  margin-bottom: 0;
                }
                .red {
                  color: #fe0000;
                }
                .blue {
                  color: #2854cb;
                }
                span {
                  margin-right: 40px;
                }
              }
            }
          }
        }
        .operation-wrap {
          padding: 0 28px;
          box-sizing: border-box;
          .operation-item {
            min-width: 230px;
            padding: 30px 20px;
            box-sizing: border-box;
            border-radius: 50px;
            font-size: 30px;
            color: #fff;
            background: #0031c9;
            margin-left: 30px;
            &:first-child {
              min-width: 200px;
            }
            .icon {
              width: 27px;
              height: 30px;
              background: url("../../../assets/images/query-icon.png") no-repeat
                center;
              background-size: cover;
              margin-right: 15px;
            }
            &.success {
              background: #333333;
            }
          }
        }
        .management-btn {
          flex-shrink: 0;
          width: 130px;
          height: 50px;
          background: #0032c9;
          border-radius: 25px;
          font-size: 26px;
          color: #fff;
          padding: 10px 35px;
          box-sizing: border-box;
          margin-left: 30px;
          cursor: pointer;
        }
      }
    }
  }
  .popup_container {
    .popup_wrap {
      width: 100%;
      // height: 500px;
      box-sizing: border-box;
      padding: 30px 0;
      .btn_item {
        width: 600px;
        height: 150px;
        border: 1px solid #a0a0a0;
        font-size: 30px;
        padding: 0 60px 0 68px;
        box-sizing: border-box;
        margin: 0 auto 30px;
        &:last-child {
          margin-bottom: 0;
        }
        .icon-youjiantou {
          font-size: 30px;
          color: #515151;
        }
      }
      .textarea_box {
        border-radius: 0;
        box-sizing: border-box;
        border: 2px solid rgba(173, 173, 173, 0.76);
        width: 90%;
        margin: 10px auto 50px;
        /deep/ .van-cell {
          width: 100%;
          height: 100%;
        }
        /deep/ .van-field__body {
          height: 100%;
        }
        /deep/ .van-field__control {
          height: 100%;
        }
      }
      .custom_btn {
        background: #373737;
        position: relative;
        width: 300px;
        height: 70px;
        text-align: center;
        line-height: 70px;
        font-size: 25px;
        color: #fff;
        margin: auto;
        border-radius: 35px;
        position: relative;
        .icon-yuyinjiantou {
          position: absolute;
          transform: rotate(-90deg);
          right: 20px;
        }
      }
    }
    .close {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 0;
      .iconfont {
        font-size: 50px;
        color: #fff;
      }
    }
  }
  .popup_filter_container {
    height: 55vh;
    padding: 50px 20px 50px 40px;
    box-sizing: border-box;
    .filter_list_wrap {
      height: 100%;
      overflow-y: scroll;
      overflow-x: hidden;
      // 自定义滚动条样式
      &::-webkit-scrollbar {
        width: 30px;
        height: 100px;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 15px;
        background: #3875c6;
      }
      .filter_item_wrap {
        width: 550px;
        height: 90px;
        background: #ffffff;
        border: 1px solid #a0a0a0;
        font-size: 30px;
        color: #000000;
        padding-left: 65px;
        box-sizing: border-box;
        margin-bottom: 10px;
        cursor: pointer;
        p {
          &:first-child {
            margin-right: 35px;
          }
        }
      }
    }
  }
}
</style>